import {
    SimplePageContentWrapper,
    SimplePageLayout
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {RecordsTable} from "../tables/RecordsTable.tsx";

export const IndexPage = ({customerId, subscriptionId}: {customerId?: string, subscriptionId?: string} = {}) => {

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader/>}
        >
            <SimplePageContentWrapper><RecordsTable customerId={customerId} subscriptionId={subscriptionId}/></SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
